import { TrackingBeacons } from '../useTrackingBeacons/transform';
import { generateEventId, sendEventToCourier, useAttributionID } from '@eventbrite/legacy-infra.clid-courier';

type PixelsTrackingOptions = {
  eventId: string;
  organizationId: string;
  environment: string;
  debugging: boolean;
  trackingBeacons: TrackingBeacons;
};

export const pixelsTracking = ({
  eventId,
  organizationId,
  environment,
  debugging,
  trackingBeacons,
}: PixelsTrackingOptions) => {
  import('@eventbrite/legacy-infra.grylls').then((grylls) => {
    const options = {
      environment,
      debugging,
      // These are hardcoded in Core
      enabled: true,
      launchSupportMultipleFacebookPixels: true,
    };

    // Check existence of window before accessing document.title
    const title = window && window.document ? window.document.title : '';

    grylls.load(trackingBeacons, options);

    // Generate synthetic event ID for Facebook deduplication
    const stableId = useAttributionID();
    const syntheticFbEventId = stableId ? generateEventId(stableId) : null;

    // Pass syntheticFbEventId to page() for PageView event deduplication
    grylls.page(title, {
      syntheticFbEventId: syntheticFbEventId,
    });

    grylls.track('event_listing', {
      eventId: eventId, // Real Eventbrite event ID
      syntheticFbEventId: syntheticFbEventId, // Our generated dedupe ID
    });

    if (syntheticFbEventId && stableId && organizationId) {
      sendEventToCourier('event_listing', syntheticFbEventId, stableId, organizationId, trackingBeacons, true, {
        eventId: eventId,
      });
    }
  });
};
